.tag {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: var(--rounded);
	width: fit-content;
	height: fit-content;
	padding: 0.2rem 0.3rem;
	gap: 0.25rem;
}

.text {
	color: var(--textSecondary);
	font-size: 0.8rem;
	text-align: left;
	white-space: nowrap;
}

.emoji {
	font-size: 0.8rem;
	width: fit-content;
	height: fit-content;
}
